import React from 'react';
import { Box, Spacer, Image, Flex, Text, ChakraProvider, theme, Link} from "@chakra-ui/react";
import UserIcon from '../assets/img/user_icon.svg';
import UserMenu from './UserMenu';
import { useStoreState } from 'easy-peasy';

const Header = (props) =>{
  const eventDetails = useStoreState( state => state.eventDetails);
  const isUserLogged = useStoreState( state => state.isUserLogged)
    return(
      <ChakraProvider theme={theme}>
      <Flex alignItems="center" position="sticky" top="0" bg="white" zIndex="910">
     
      <Box pt="4" pb="4" pl="4" zIndex="909">
        <UserMenu/>
      </Box>
      <Spacer />
      <Box pt="4" pb="4">
        <Text
        fontSize={15}
        color="#222222"
        fontWeight={700}
        textAlign={'center'}>{props.title}</Text>
        <Text
        fontSize={12}
        color="#666666"
        fontWeight={400}
        textAlign={'center'}>{eventDetails.event_name}</Text>
      </Box>
      <Spacer />
      <Link href={`${process.env.PUBLIC_URL+"/events"}`} key="login-showroom">
      {
        (isUserLogged) ? <Box pt="4" pb="4" pr="4">
          <Image 
            src={UserIcon}
            alt="User Icon"
            objectFit="cover"
            w="6"
            h="6"/>
          </Box> : " "
      }
      </Link>
    </Flex>
    </ChakraProvider>
)}
export default Header; 
